'use client'

import { useCallback, useEffect, useState } from 'react'
import { TAILWIND_SCREENS } from '@/lib/common/utils/getTailwindScreens'
import { createClientLogger } from '@/lib/logger/client'

const log = createClientLogger('useTailwindScreen')

function useInnerWidth() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.innerWidth)
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  })
  return width
}

export function useTailwindScreen() {
  const screens: Record<string, string> = TAILWIND_SCREENS
  const width = useInnerWidth()

  const getScreen = useCallback(() => {
    let matchedScreen = null as string | null
    for (const [name, size] of Object.entries(screens)) {
      if (typeof size === 'number' && width >= size) {
        matchedScreen = name
      } else if (typeof size === 'string') {
        if (size.endsWith('px') && width >= parseFloat(size.slice(0, -2))) {
          matchedScreen = name
        } else if (!size.endsWith('px')) {
          log.error({ size }, 'Invalid screen size format')
        }
      }
    }
    if (!matchedScreen) matchedScreen = 'sm'
    return matchedScreen
  }, [width, screens])

  const [screen, setScreen] = useState(getScreen())
  useEffect(() => {
    setScreen(getScreen())
  }, [width, getScreen])

  return screen as keyof typeof TAILWIND_SCREENS
}
